import { CUT_REQUESTED_PREFIX } from '../api/services/videoService';

// What this browser keeps for the signed-in person outside the store (28 Oct, the sign-in build, item 3), removed when
// they sign out: in this tab by services/signOut.ts, in every other open tab by the session bridge when Firebase reports
// the sign-out there (components/FirebaseAuthSessionBridge.tsx).
//   - sessionStorage: the clip-cut markers (clipCutRequested:*, api/services/videoService.ts);
//   - localStorage: the licence acceptances an older build kept in the browser (cw_license_acceptances_v1; nothing
//     writes it since 26 Oct, hooks/useLicenseAcceptance.ts).
// KEPT: the site-gate pass (sessionStorage `preview_ok`, components/PasswordGate.tsx), which belongs to the site, not
// the person; and the upload history, which is kept per person (utils/uploadHistory.ts: each account sees only its
// own, so it survives a sign-out for that person and shows nothing to anyone else; Joey, 28 Oct). Each part is tried on
// its own; nothing here throws.

const OLD_LICENCE_ACCEPTANCES_KEY = 'cw_license_acceptances_v1';

export const forgetPersonInThisBrowser = (): void => {
  try {
    const keys: string[] = [];
    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      const key = window.sessionStorage.key(i);
      if (key && key.startsWith(CUT_REQUESTED_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => window.sessionStorage.removeItem(key));
  } catch {
    console.error('Sign-out: the clip-cut markers could not be removed');
  }
  try {
    window.localStorage.removeItem(OLD_LICENCE_ACCEPTANCES_KEY);
  } catch {
    console.error('Sign-out: the old licence acceptances could not be removed');
  }
};
